export default __webpack_public_path__ + "static/media/empty_state.34c49286.png";